import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Cross');

const Cross = (props) => {
    const { className, type } = props;
    return (
        <div className={bem('circle', type, className)}>
            <div className={bem('dot', type)} />
            <div className={bem('bar1', type)} />
            <div className={bem('bar2', type)} />
            <div className={bem('topHalfWindow', type)} />
            <div className={bem('bottomHalfWindow', type)} />
            <div className={bem('centerWindow', type)} />
        </div>
    );
};

Cross.propTypes = {
    type: PropTypes.string,
    className: PropTypes.string,
};

Cross.defaultProps = {};

export default Cross;
